import {
  Component,
  EventEmitter,
  Input,
  Output,
  OnChanges,
} from "@angular/core";
import { BacDashboardInformation } from "../../../../core/models/dashboard-poc/bacDashboardInformation";
import * as FileSaver from "file-saver";
import { BacDashboardDto } from "../../../../core/models/dashboard-poc/bacDashboardDto";
import { BcLedgerStacker } from "../../../../core/models/bcLedger/bcLedgerStacker";
import { DashbaordPocAdditionalFilters } from "../../../../core/models/common/dashboardPocAdditionalFilters.dto";
import { SharedService } from "../../../../core/services/shared.service";
import { BCLedgerFilter } from "../../../../core/models/bcLedger/bclegderfilter";
import { CommonModule } from "@angular/common";
import { SupportMapPieChartComponent } from "../support-map-pie-chart/support-map-pie-chart.component";
import { ModalStackerComponent } from "../../../../shared/components/modal-stacker/modal-stacker.component";
import { OrdersComponent } from "../../../orders/orders.component";
import { YTDGPComponent } from "../../../bcledger/components/ytdgp/ytdgp.component";
import { TableModule } from "primeng/table";

@Component({
  selector: "jni-bc-bac-support-breakdown",
  templateUrl: "./bc-bac-support-breakdown.component.html",
  styleUrls: ["./bc-bac-support-breakdown.component.scss"],
  imports: [
    CommonModule,
    SupportMapPieChartComponent,
    ModalStackerComponent,
    OrdersComponent,
    YTDGPComponent,
    TableModule,
  ],
})
export class BcBacSupportBreakdownComponent implements OnChanges {
  @Input()
  bacDashboardInformation: BacDashboardInformation[] = [];

  @Input()
  dashbaordPocAdditionalFilters: DashbaordPocAdditionalFilters =
    {} as DashbaordPocAdditionalFilters;

  @Input() totals: BacDashboardDto = {} as BacDashboardDto;

  @Input() fromComponent = "";

  @Input() bcLedgerFilter!: BCLedgerFilter;

  @Output() closeSalesOrderModel = new EventEmitter<true>();

  @Output() openOrderListingModal = new EventEmitter<boolean>();

  pieChart: BacDashboardInformation[] = [];
  bcSelectedId!: string;
  category = "portal";
  fileName = "dashboard";

  orderListingDisplayModal = false;
  bcLedgerStacker: BcLedgerStacker = {} as BcLedgerStacker;
  displayModal = false;

  constructor(private _sharedService: SharedService) {}

  ngOnChanges(): void {
    this.pieChart = this.bacDashboardInformation;
  }

  closeOrderListingModal() {
    this.closeSalesOrderModel.emit(true);
    this.openOrderListingModal.emit(false);
    // this.orderListingDisplayModal = false;
  }

  clickTotalBillGp(obj: BacDashboardInformation) {
    if (obj.supportBreakDown == "Others") {
      this.onStackingRedirect(
        "YTDGP",
        this.bcLedgerFilter?.brandingConsultantID ?? "",
        this.bcLedgerFilter?.fromDate ?? "",
        this.bcLedgerFilter?.toDate ?? "",
        this.category
      );
    } else {
      const objData = this.setTheDashboardPocAdditionalFilterObject(obj);
      objData.status = "Invoiced";
      this._sharedService.setDashbaordPocAdditionalFiltersObject(objData);
      // this.orderListingDisplayModal = true;
      this.openOrderListingModal.emit(true);
    }
    // this._router.navigate(['orders/orderslist/1']);
  }

  clickTotalOpenGp(obj: BacDashboardInformation) {
    const objData = this.setTheDashboardPocAdditionalFilterObject(obj);
    objData.status = "Open order";
    this._sharedService.setDashbaordPocAdditionalFiltersObject(objData);
    // this.orderListingDisplayModal = true;
    this.openOrderListingModal.emit(true);
    // this._router.navigate(['orders/orderslist/1']);
  }

  setTheDashboardPocAdditionalFilterObject(obj: BacDashboardInformation) {
    const dashbaordPocAdditionalFilters: DashbaordPocAdditionalFilters = {
      additionalFilters: true,
      bacNumber:
        this.fromComponent == "bac-report"
          ? this.dashbaordPocAdditionalFilters.brandingConsultant
          : obj.bcNumber,
      brandingConsultant:
        this.fromComponent == "bac-report" ? obj.bcNumber : "",

      applyNonAdminRules: !(this.fromComponent == "bac-report"),
      brandingConsultantNumber:
        this.fromComponent == "bac-report"
          ? ""
          : this.dashbaordPocAdditionalFilters.brandingConsultant,
    } as DashbaordPocAdditionalFilters;
    return dashbaordPocAdditionalFilters;
  }

  exportExcelFile() {
    const object = this.bacDashboardInformation.map(datum => {
      return {
        ["Employee Id"]: datum.bcNumber,
        ["Support"]: datum.supportBreakDown,
        ["Title"]: datum.title,
        ["Support %"]: datum.supportPercentage,
        ["Total Bill GP$"]: datum.totalBillGp,
        ["Total Open GP (backlog)"]: datum.totalOpenGP,
      };
    });

    import("xlsx").then(xlsx => {
      const worksheet = xlsx.utils.json_to_sheet(object);
      const workbook = { Sheets: { data: worksheet }, SheetNames: ["data"] };
      const excelBuffer: ArrayBuffer = xlsx.write(workbook, {
        bookType: "xlsx",
        type: "array",
      });
      this.saveAsExcelFile(excelBuffer, "Dashboard-Support-Allocation");
    });
  }

  saveAsExcelFile(buffer: ArrayBuffer, fileName: string): void {
    const EXCEL_TYPE =
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
    const EXCEL_EXTENSION = ".xlsx";
    const data: Blob = new Blob([buffer], {
      type: EXCEL_TYPE,
    });
    FileSaver.saveAs(
      data,
      fileName + "_export_" + new Date().getTime() + EXCEL_EXTENSION
    );
  }

  onStackingRedirect(
    path: string,
    brandingConsultantID: string,
    fromDate: string,
    toDate: string,
    CategoryID: string
  ) {
    fromDate = new Date(
      this.bcLedgerFilter.fromDate ?? ""
    ).toLocaleDateString();
    toDate = new Date(this.bcLedgerFilter.toDate ?? "").toLocaleDateString();

    path = path.replace(/[^a-zA-Z ]/g, "").replace(/\s/g, "");

    this.bcLedgerStacker.Path = path;
    this.bcLedgerStacker.BrandingConsultantID = brandingConsultantID ?? "";
    this.bcLedgerStacker.FromDate = fromDate;
    this.bcLedgerStacker.ToDate = toDate;
    this.bcLedgerStacker.CategoryID = CategoryID;
    this.displayModal = true;
  }

  closeBcLedgerModal() {
    this.displayModal = false;
  }
}
